import { getState } from '../redux/store/configureStore';
import { isEmpty, isNil } from 'lodash';

export function getDataType(name) {
  const {
    staticData
  } = getState();

  return staticData[name];
}


/**
 * referralsByRole - Filters referral sources by the desc property
 *
 * @param  {array} foundUsViaList A list of referral types
 * @param  {string} role          A for applicant, C for contact
 * @return {array}                Array of referral types filtered by role
 */
export function referralsByRole(foundUsViaList = [], role = 'A') {
  if (isEmpty(foundUsViaList)) {
    return foundUsViaList;
  }
  if (isNil(role) || !['A', 'C'].includes(role)) {
    role = 'A';
  }

  return foundUsViaList.filter(ref => [null, role].includes(ref.desc));
}



// WEBPACK FOOTER //
// ./shared/lib/staticData.js